import { render, staticRenderFns } from "./BitacoraForm.vue?vue&type=template&id=76f4ad36&scoped=true"
import script from "./BitacoraForm.vue?vue&type=script&lang=js"
export * from "./BitacoraForm.vue?vue&type=script&lang=js"
import style0 from "./BitacoraForm.vue?vue&type=style&index=0&id=76f4ad36&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "76f4ad36",
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("D:\\a\\1\\s\\node_modules\\vue-hot-reload-api\\dist\\index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('76f4ad36')) {
      api.createRecord('76f4ad36', component.options)
    } else {
      api.reload('76f4ad36', component.options)
    }
    module.hot.accept("./BitacoraForm.vue?vue&type=template&id=76f4ad36&scoped=true", function () {
      api.rerender('76f4ad36', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "src/views/infra/proposalProcess/components/Bitacora/BitacoraForm.vue"
export default component.exports